module.exports = __webpack_public_path__ + "public/img/Menghitung Tunjangan di Excel untuk HR.9a419882.png";